import { Injectable } from '@angular/core';
import { BusinessLineRequest } from '@cemex-core/cmx-api/models/business-lines/business-lines-request';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs/operators';
import { CxApiMetadataService, CxApiMetadataStrategy } from '../cx-api-metadata/cx-api-metadata.service';
import CxProductTypeActions from './store/actions/cx-product-type.actions';
import { CxProductTypeEntity, CxProductTypeState } from './store/reducers/cx-product-type.reducer';
import * as cxProductTypeSelector from './store/selectors/cx-product-types.selector';
import { CxApiMetadataEntity } from '../cx-api-metadata/store/reducers/cx-api-metadata.reducer';

@Injectable({
  providedIn: 'root',
})
export class CxProductTypeService {
  constructor(
    private store: Store<CxProductTypeState>,
    private cxApiMetadata: CxApiMetadataService,
  ) {}

  public selectProductTypes$(productTypeRequest: BusinessLineRequest, strategy?: CxApiMetadataStrategy) {
    return this.cxApiMetadata.connectMetadata$(CxProductTypeActions.fetchEntity(productTypeRequest), strategy).pipe(
      switchMap((metadata) =>
        this.store.select(cxProductTypeSelector.selectCxProductTypesById(), { ids: metadata.entityIds }).pipe(
          filter((res) => res.length === metadata.entityIds.length),
          map((res) => [res, metadata] as [CxProductTypeEntity[], CxApiMetadataEntity]),
        ),
      ),
    );
  }

  public selectActive$() {
    return this.store.select(cxProductTypeSelector.selectActiveCxProductType);
  }

  public setActive(entityId: string | number) {
    return this.store.dispatch(CxProductTypeActions.selectEntity({ id: `${entityId}` }));
  }
}
